import { homePageContent } from './homePage';
import { teamContent } from './team';
import { servicesPageContent } from './servicesPage';

const content = {
  homePage: homePageContent,
  team: teamContent,
  servicesPage: servicesPageContent,
};

export default content;
